// extracted by mini-css-extract-plugin
export default {"orderList":"TabletOrderList_orderList__FrXtr","orderList__paginationBtn":"TabletOrderList_orderList__paginationBtn__FldX0"};